/**
 * Offer Coordinator — lets product-page "offers" (Complete the Bundle,
 * Quantity Break) route through the theme's main Add-to-cart button.
 *
 * Offers register themselves and call select()/clear() as the shopper picks or
 * deselects them. While an offer is active:
 *   - the main product form's submit is hijacked and the offer is added instead
 *     of the plain single product;
 *   - the main button label shows the offer (e.g. "Add bundle · Dhs 278");
 *   - the native dynamic checkout ("Buy it now") is hidden (it can't carry a
 *     multi-line offer).
 * With no offer selected, the product form behaves normally.
 *
 * Offer contract: { label(): string, submit(): void, deselect(): void }
 */
(function () {
  if (window.OfferCoordinator) return;

  var offers = [];
  var active = null;
  var busy = false;

  function mainButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-form__submit'));
  }
  function dynamicCheckouts() {
    return Array.prototype.slice.call(document.querySelectorAll('.shopify-payment-button'));
  }
  function labelSpan(btn) { return btn.querySelector('span'); }

  function updateUI() {
    mainButtons().forEach(function (btn) {
      var sp = labelSpan(btn);
      if (btn.dataset.ocOrig === undefined) {
        btn.dataset.ocOrig = sp ? sp.textContent : btn.textContent;
      }
      var text = active ? active.label() : btn.dataset.ocOrig;
      if (sp) sp.textContent = text; else btn.textContent = text;
      if (active) {
        // An offer doesn't depend on the main variant's availability.
        btn.disabled = false;
        btn.removeAttribute('disabled');
      }
    });
    dynamicCheckouts().forEach(function (el) { el.style.display = active ? 'none' : ''; });
  }

  function setSpinner(on) {
    mainButtons().forEach(function (btn) {
      var sp = btn.querySelector('.loading__spinner');
      if (on) { btn.classList.add('loading'); btn.disabled = true; if (sp) sp.classList.remove('hidden'); }
      else { btn.classList.remove('loading'); if (sp) sp.classList.add('hidden'); }
    });
    if (!on) updateUI();
  }

  // Capture-phase submit runs before the theme's own product-form handler, so
  // stopImmediatePropagation() prevents the plain product from also being added.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    if (!active) return; // nothing selected — let the normal single-product add proceed
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return; // guard against a rapid second click adding the offer twice
    busy = true;
    setSpinner(true);
    var result;
    try { result = active.submit(); } catch (err) { result = null; }
    Promise.resolve(result).then(done, done);
    function done() { busy = false; setSpinner(false); }
  }, true);

  window.OfferCoordinator = {
    register: function (offer) { if (offers.indexOf(offer) === -1) offers.push(offer); updateUI(); },
    select: function (offer) {
      if (active && active !== offer && active.deselect) { try { active.deselect(); } catch (e) {} }
      active = offer;
      updateUI();
    },
    clear: function (offer) { if (active === offer) { active = null; updateUI(); } },
    isActive: function (offer) { return active === offer; },
    refresh: updateUI
  };
})();
